import { Column } from '../../model/common/column';

export function getMOCEventsForAORTableDefinition(): Column[] {
  return [
    {
      field: 'startDt',
      header: 'COMMON.LABEL.START_DATE',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '20%',
      dateFormat: 'yyyy-MM-dd',
      sortable: false,
      filterable: false,
    },
    {
      field: 'endDt',
      header: 'COMMON.LABEL.END_DATE',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '20%',
      dateFormat: 'yyyy-MM-dd',
      sortable: false,
      filterable: false,
    },
    {
      field: 'title',
      header: 'CRM.LABEL.TITLE',
      formatPattern: 'hyperlink',
      width: '60%',
      sortable: false,
      filterable: false,
    },
  ];
}
